import React from "react";

import { useIntl } from "react-intl";
import styled from "styled-components";

import { APP_NAME } from "Constants/documentationUrls";
import HelloWorldIllustration from "Vendor_resources/images/hello-world.svg";
import LoginLeftLogo from "Vendor_resources/images/login-left-logo.svg";

const BodyText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
`;

const Subtitle = styled(BodyText)`
  margin: 32px 0 64px;
  text-align: center;
`;

const Header = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: var(--section-night-color, var(--night));
  line-height: 48px;
  text-align: center;
  margin: 0;

  sub {
    font-size: 20px;
    line-height: 32px;
    vertical-align: super;
  }
`;

const MergerIconLayout = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;

const LeftLayout = styled.div`
  background-image: url("images/generic_background.svg");
  background-size: cover;
  padding: 0 100px 0 100px;
  justify-content: center;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 940px) {
    display: none;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const MainLeftPane = () => {
  const intl = useIntl();

  return (
    <LeftLayout>
      <div>
        <MergerIconLayout>
          <img src={LoginLeftLogo} alt="Login Logo" />
        </MergerIconLayout>
        <Header tag="h1">
          {intl.formatMessage(
            { id: "auth.left_panel.title" },
            {
              sub: text => <sub>{text}</sub>
            }
          )}
        </Header>
        {intl.messages["auth.left_panel.description"] && (
          <Subtitle>
            {intl.formatMessage(
              { id: "auth.left_panel.description" },
              { appName: APP_NAME }
            )}
          </Subtitle>
        )}
        <ImageContainer>
          <img src={HelloWorldIllustration} alt="A computer running" />
        </ImageContainer>
      </div>
    </LeftLayout>
  );
};

export default MainLeftPane;
